<div class="img-preview">

  <ng-container *ngIf="!useImagePreview; else defaultTpl">
    <span class="cursor-pointer" [ngClass]="ctaLabelClass" (click)="onClickPreview(src??'')">{{ ctaLabel }}</span>
  </ng-container>

  <ng-template #defaultTpl>
    <div [class]="'img-container cursor-pointer h-' + height.toString() + 'px w-auto'" (click)="onClickPreview(src??'')">
      <img src="{{src ? src : imgDefault}}" alt="testing">
    </div>
  </ng-template>

  <ng-template #modal>
      <span
        style="top: -30px; right: -30px"
        class="icon-close position-absolute {{!disablePreview && 'cursor-pointer'}}"
        (click)="close()"
        [inlineSVG]="STRING_CONSTANTS.ICON.IC_BULLET_CLOSE_WHITE"></span>
    <img src="{{src}}" alt="testing" class="img-preview-main" (click)="close()">
  </ng-template>
</div>
